import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import GetInventoryOrderButton from '../../OrderItem/GetInventoryOrderButton';
import StopOrderButton from '../../OrderItem/StopOrderButton';
import CheckKeys from '../../CheckKeys';
import CancelOrderButton from '../../OrderItem/CancelOrderButton';
import PrintManualApproveOrder from '../../../../Components/PrintManualApproveOrder';
import VerifyButton from '../../VerifyButton';
import PrintOrderForm from '../../../../Components/PrintOrderForm';
import ApproveButton from '../../ApproveButton';

function ColumnButtons({
  orderId,
  status,
  afterSuccess,
  filled,
  stateReducer,
  checkCodes,
  cancelOrder,
  getInventoryOrder,
  fetchOrderInfo,
  stopOrder,
  stopOrderReset,
  manualApproval,
  isManager
}) {
  const isSelfApprovalEnabled = useSelector(
    (state) => state.core.account.payload?.params?.selfApproval === true,
    shallowEqual
  );

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '0.5fr 0.5fr', gap: '4px' }}>
      {isManager &&
      <>
      {((status === 1 && manualApproval) || status === 8) && (
      <PrintManualApproveOrder
      afterSuccess={afterSuccess}
                orderId={orderId}
              />
      )}
      {([9].includes(status)) && (
      <VerifyButton 
        afterSuccess={afterSuccess}
        orderId={orderId}
        />
      )}
      {([1, 2, 8].includes(status)) && (
        <StopOrderButton
          afterSuccess={afterSuccess}
          orderId={orderId}
          stateReducer={stateReducer}
          fetchOrderInfo={fetchOrderInfo}
          stopOrder={stopOrder}
          stopOrderReset={stopOrderReset}
        />
      )}
      {([3, 9].includes(status)) && (
            <CancelOrderButton
              orderId={orderId}
              afterSuccess={afterSuccess}
              filled={filled}
              stateReducer={stateReducer}
              cancelOrder={cancelOrder}
            />
      )}
      {([3, 4].includes(status)) && (
        <CheckKeys
          afterSuccess={afterSuccess}
          orderId={orderId}
          checkCodes={checkCodes}
        />
      )}
      </>
    }
    {!isManager && isSelfApprovalEnabled && status === 9 && (
      <ApproveButton
        afterSuccess={afterSuccess}
        orderId={orderId}
      />
    )}
    {!isManager && ([9].includes(status)) && (
            <CancelOrderButton
              orderId={orderId}
              afterSuccess={afterSuccess}
              filled={filled}
              stateReducer={stateReducer}
              cancelOrder={cancelOrder}
            />
      )}
      {status === 3 && (
          <GetInventoryOrderButton
            orderId={orderId}
            getInventoryOrder={getInventoryOrder}
          />
        )}
       {status === 9 && <PrintOrderForm status={status} orderId={orderId} afterSuccess={afterSuccess} isManager={isManager} toEdit={true}/>} 
    </div>
  );
}

export default React.memo(ColumnButtons);
